import { call, select, takeEvery } from 'redux-saga/effects';
import { reportError } from 'helpers/error-logging';
import { makePath } from 'helpers/link-generation';
import { selectActiveVenueId } from 'selectors/general';
import { ACTIVE_VENUE_CHANGED } from 'features/App/App.saga';
import { doFetchVenueSmartspotData } from 'components/SmartSpot';

export function* handleActiveVenueChange(client, action) {
  try {
    const { venueId } = action;
    yield call(client.navigate, makePath.smartTools(venueId));
  } catch (error) {
    reportError(error);
  }
}

export function* handleRouteEnter(client) {
  try {
    const venueId = yield select(selectActiveVenueId);
    yield call(doFetchVenueSmartspotData, client, { venueId });
  } catch (error) {
    reportError(error);
  }
}

export function* watchActions(client) {
  yield takeEvery(ACTIVE_VENUE_CHANGED, handleActiveVenueChange, client);
}
